import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
});

// Chat
export const sendMessage = (message, sessionId) =>
  api.post('/chat', { message, session_id: sessionId }).then(r => r.data);

export const sendMessageStream = async function* (message, sessionId) {
  const resp = await fetch(`${BASE_URL}/chat/stream`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, session_id: sessionId }),
  });
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const lines = buf.split('\n');
    buf = lines.pop();
    for (const line of lines) {
      if (line.startsWith('data: ')) {
        try { yield JSON.parse(line.slice(6)); } catch {}
      }
    }
  }
};

// Atoms / Knowledge Graph
export const getAtoms = (domain = null, limit = 200) =>
  api.get('/atoms', { params: { domain, limit } }).then(r => r.data);

export const getRecentAtoms = (limit = 20) =>
  api.get('/atoms/recent', { params: { limit } }).then(r => r.data);

export const searchAtoms = (q, limit = 10) =>
  api.get('/atoms/search', { params: { q, limit } }).then(r => r.data);

export const deleteAtoms = (topic) =>
  api.delete('/atoms', { data: { topic, confirm: true } }).then(r => r.data);

// Goals
export const getGoals = () =>
  api.get('/goals').then(r => r.data);

// Insights
export const getInsights = () =>
  api.get('/insights').then(r => r.data);

export const acknowledgeInsight = (eventId) =>
  api.post(`/insights/${eventId}/acknowledge`).then(r => r.data);

// Status
export const getStatus = () =>
  api.get('/status').then(r => r.data);

// Document ingestion
export const uploadDocumentPreview = (file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/ingest/document/preview', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export const confirmDocumentIngest = (preview) =>
  api.post('/ingest/document/confirm', preview).then(r => r.data);

// Finance
export const uploadFinanceCSV = (file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/connectors/finance/csv', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

// LLM Configuration
export const getLLMConfig = () =>
  api.get('/llm/config').then(r => r.data);

export const setLLMConfig = (provider, enabled) =>
  api.post('/llm/config', { provider, enabled }).then(r => r.data);

// WebSocket
export const createWebSocket = (sessionId) => {
  const wsUrl = (BASE_URL.replace('http', 'ws')).replace('/api/v1', '');
  return new WebSocket(`${wsUrl}/ws/${sessionId}`);
};
